import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface TreasuryEntry {
  id: string;
  report_date: string;
  capital_start: number;
  daily_volume: number;
  daily_revenue: number;
  daily_expenses: number;
  result: number;
  bank_balance: number;
  mtn_balance: number;
  crypto_available: number;
  financial_stock: number;
  gap: number;
  comment: string;
  created_at: string;
  updated_at: string;
}

export interface TreasurySummary {
  total_capital_start: number;
  total_daily_volume: number;
  total_daily_revenue: number;
  total_daily_expenses: number;
  total_result: number;
  total_bank_balance: number;
  total_mtn_balance: number;
  total_crypto_available: number;
  total_financial_stock: number;
  total_gap: number;
  entry_count: number;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token}` };
};

interface ListParams {
  skip?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
}

export const treasuryReportingService = {
  async listEntries(params: ListParams = {}) {
    const res = await axios.get(`${BACKEND_URL}/treasury-reporting/list`, {
      headers: getAuthHeaders(),
      params,
    });
    return res.data;
  },

  async createEntry(data: Partial<TreasuryEntry>) {
    const res = await axios.post(`${BACKEND_URL}/treasury-reporting/create`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  async updateEntry(entryId: string, data: Partial<TreasuryEntry>) {
    const res = await axios.put(`${BACKEND_URL}/treasury-reporting/update/${entryId}`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  async deleteEntry(entryId: string) {
    const res = await axios.delete(`${BACKEND_URL}/treasury-reporting/delete/${entryId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  async summary(params: { date_from?: string; date_to?: string } = {}) {
    const res = await axios.get(`${BACKEND_URL}/treasury-reporting/summary`, {
      headers: getAuthHeaders(),
      params,
    });
    return res.data;
  },

  async downloadExcel(params: { date_from?: string; date_to?: string }) {
    const res = await axios.get(`${BACKEND_URL}/treasury-reporting/download`, {
      headers: getAuthHeaders(),
      params,
      responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `treasury_reporting_${new Date().toISOString().slice(0, 10)}.xlsx`;
    link.click();
    URL.revokeObjectURL(link.href);
  },
};
